import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const UserGroup_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.1447 11.3557C12.8963 11.8096 12.5991 12.233 12.2601 12.6187C12.4983 12.8598 12.7689 13.0687 13.0649 13.2384C12.8322 13.3296 12.611 13.4377 12.4017 13.5612C12.8446 13.8485 13.2185 14.2331 13.4931 14.6848C13.9113 14.5011 14.3898 14.3992 14.9269 14.3992C16.3504 14.3992 17.362 15.1154 17.9324 16.1715C18.1292 16.5359 18.5842 16.6718 18.9487 16.475C19.3131 16.2781 19.449 15.8231 19.2522 15.4587C18.7146 14.4632 17.8772 13.6649 16.7889 13.2384C17.9163 12.5919 18.6758 11.3765 18.6758 9.98375C18.6758 7.91326 16.9974 6.23479 14.9269 6.23479C14.5404 6.23479 14.1676 6.29327 13.8168 6.40187C13.9318 6.89467 13.9949 7.40748 13.9997 7.9342C14.2824 7.80611 14.5963 7.73479 14.9269 7.73479C16.1689 7.73479 17.1758 8.74168 17.1758 9.98375C17.1758 11.2258 16.1689 12.2327 14.9269 12.2327C14.2013 12.2327 13.556 11.8891 13.1447 11.3557Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.95552 4.22974C4.92635 4.22974 3.28138 5.87471 3.28138 7.90388C3.28138 9.93305 4.92635 11.578 6.95552 11.578C8.98469 11.578 10.6297 9.93305 10.6297 7.90388C10.6297 5.87471 8.98469 4.22974 6.95552 4.22974ZM1.78138 7.90388C1.78138 5.04628 4.09792 2.72974 6.95552 2.72974C9.81312 2.72974 12.1297 5.04628 12.1297 7.90388C12.1297 10.1408 10.7101 12.0462 8.72273 12.7684C10.6662 13.2445 12.1335 14.5036 13.0227 16.15C13.2195 16.5144 13.0837 16.9694 12.7192 17.1663C12.3547 17.3631 11.8997 17.2272 11.7029 16.8628C10.8039 15.1981 9.19599 14.0612 6.95552 14.0612C4.71506 14.0612 3.10717 15.1981 2.20815 16.8628C2.01132 17.2272 1.5563 17.3631 1.19184 17.1663C0.827384 16.9694 0.691498 16.5144 0.888331 16.15C1.77751 14.5036 3.24485 13.2445 5.18831 12.7684C3.20092 12.0462 1.78138 10.1408 1.78138 7.90388Z"
            />
        </SvgStyled>
    );
};

export default UserGroup_sm;
